import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/admin/overtime/`;

const getAdminOvertimes = async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return await axios.get(API_URL + (queryString ? `?${queryString}` : ''));
};

const getAdminOvertime = async (id) => {
    return await axios.get(API_URL + id);
};

const addAdminOvertime = async (overtimeData) => {
    return await axios.post(API_URL, overtimeData);
};

const editAdminOvertime = async (id, overtimeData) => {
    return await axios.put(API_URL + id, overtimeData);
};

const deleteAdminOvertime = async (id) => {
    return await axios.delete(API_URL + id);
};

const AdminOvertimeService = {
    getAdminOvertimes,
    getAdminOvertime,
    addAdminOvertime,
    editAdminOvertime,
    deleteAdminOvertime
};

export default AdminOvertimeService;

